import React from 'react';

// Components
import LoadingShimmer from 'Shared/components/LoadingShimmer/LoadingShimmer';

// Styles
import './MeetingItemCommentsLoading.scss';

type Props = {
  countToRender?: number;
};

const MeetingItemCommentsLoading = ({ countToRender = 2 }: Props) => {
  const baseClassName = 'MeetingItemCommentsLoading';

  const Items = () => {
    return (
      <>
        {Array.from({ length: countToRender }, (_, k) => (
          <div key={k} className={`${baseClassName}__item`}>
            <div className={`${baseClassName}__item__header`}>
              <div className={`${baseClassName}__item__header__avatar`}>
                <LoadingShimmer shape="circle" width="24px" height="24px" />
              </div>
              <LoadingShimmer shape="rectangle" width="125px" height="14px" />
            </div>
            <div className={`${baseClassName}__item__body`}>
              <LoadingShimmer shape="rectangle" width="250px" height="16px" />
            </div>
          </div>
        ))}
      </>
    );
  };
  return (
    <div className={baseClassName}>
      <Items />
    </div>
  );
};

export default MeetingItemCommentsLoading;
